<template>
    <div class="homepage__engage-points">
        <div class="homepage__engage-points-wrap">
            <h2 class="title">Boost your students' engagement and scores!</h2>
            <ul class="list">
                <li class="item">
                    <div class="visual-wrap">
                        <img
                            class="visual visual-1"
                            src="/images/lp/engage-visual-1.svg"
                            alt=""
                        />
                    </div>
                    <div class="content">
                        <span class="nr">1.</span>
                        <h3 class="item-title">Sign up in seconds</h3>
                        <p>
                            Create an account on our website and get started in
                            just 1 minute. Once you've signed up, you'll have
                            access to all of our free, standards-aligned games.
                            You can easily import your classes from Google or
                            Clever.
                        </p>
                    </div>
                </li>
                <li class="item">
                    <div class="visual-wrap">
                        <img
                            class="visual visual-2"
                            src="/images/lp/engage-visual-2.svg"
                            alt=""
                        />
                    </div>
                    <div class="content">
                        <span class="nr">2.</span>
                        <h3 class="item-title">
                            Choose from 1000 skills to practice
                        </h3>
                        <p>
                            Select the math facts or skills you want your
                            students to practice, and we'll generate problems
                            based on your selection. Students only need to enter
                            the code displayed on your screen to join the game.
                        </p>
                    </div>
                </li>
                <li class="item">
                    <div class="visual-wrap">
                        <img
                            class="visual visual-3"
                            src="/images/lp/engage-visual-3.svg"
                            alt=""
                        />
                    </div>
                    <div class="content">
                        <span class="nr">3.</span>
                        <h3 class="item-title">
                            Monitor progress with detailed reports
                        </h3>
                        <p>
                            Our detailed game reports help you to track
                            students' progress and identify areas for
                            improvement. You can use this information to adjust
                            your approach and ensure students are meeting
                            standards.
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.homepage {
    &__engage-points {
        background-color: #fff;
        width: 100%;
        overflow: hidden;
    }

    &__engage-points-wrap {
        width: 100%;
        max-width: 960px;
        margin: 0 auto;
        padding: 5rem 2rem 3rem;
        box-sizing: border-box;

        @include mq($w-max-phone, max) {
            padding: 3rem 1rem 2rem;
        }

        .title {
            margin: 0 0 1.5rem;
            padding: 0;
            font-weight: 700;
            font-size: 32px;
            line-height: 39px;
            color: #333333;
            text-align: center;

            @include mq($w-max-phone, max) {
                margin-bottom: 0;
                font-size: 24px;
                line-height: 29px;
            }
        }

        .list {
            margin: 0 auto;
            padding: 0;
            list-style: none;
        }

        .item {
            display: flex;
            align-items: center;
            padding: 2.5rem 0;

            @include mq($w-max-sm, max) {
                flex-direction: column;
                max-width: 600px;
                margin: 0 auto;
            }

            @include mq($w-max-phone, max) {
                padding: 2rem 0;
            }

            .visual {
                display: block;
                max-width: 100%;
                height: auto;
                margin: 0 auto;

                &-wrap {
                    flex: 1;
                    max-width: 330px;
                }

                @include mq($w-max-phone, max) {
                    margin-bottom: 2rem;
                }
            }

            &-title {
                margin: 0 0 0.75rem;
                padding: 0;
                font-size: 26px;
                line-height: 32px;
                font-weight: 700;
                color: #333333;

                @include mq($w-max-phone, max) {
                    font-size: 18px;
                    line-height: 22px;
                }
            }

            .content {
                flex: 1;
                padding-left: 4rem;

                @include mq($w-max-sm, max) {
                    padding-left: 0;
                }

                @include mq($w-max-phone, max) {
                    text-align: center;
                    position: relative;
                }

                .nr {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 72px;
                    height: 65px;
                    margin-bottom: 0.75rem;
                    background: url('/images/lp/bg-nr.svg') no-repeat;
                    font-size: 36px;
                    font-weight: 700;
                    color: #fff;

                    @include mq($w-max-phone, max) {
                        margin: 0 auto 1rem auto;
                        position: absolute;
                        bottom: 100%;
                        left: 50%;
                        transform: translateX(-150%);
                    }
                }

                p {
                    margin: 0;
                    padding: 0;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 20px;
                    color: #333;

                    @include mq($w-max-phone, max) {
                        font-size: 16px;
                        line-height: 20px;
                    }
                }
            }
        }
    }
}
</style>
